import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import userBottomImg from "../../src/asset/images/partner-portal/person-images/pancard.png";
import HeaderPartner from "./HeaderPartner";
import PageProgressBarPartner from "./PageProgressBarPartner";
import CheckmarkIcon from "../asset/images/partner-portal/checkmark.svg";
import {
  dateInput,
  decryptData,
  digitValidate,
  encryptData,
  oneDigit,
  panInputResist,
  shareError,
  validatePan,
  validatePartnerEmail,
} from "../CommonMethods/CommonMethods";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import DateCustom from "./DateCustom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { Partner_Portal } from "../Configuration/API_URL";
import { toast } from "react-toastify";
import SmallLoader from "../Components/Common/smallLoader";
import axios from "axios";
import FormFooterPartner from "./FormFooterPartner";
import editNumber from "../asset/images/revamp-images/editImg.svg";
import previosPageArrow from "../asset/images/revamp-images/previousPageBtn.svg";
import PageSideBar from "./PageSideBar";

const otpFields = ["otp1", "otp2", "otp3", "otp4"];

const PANDetailPagePartner = (props) => {
  const navigate = useNavigate("");
  const partnerToken = localStorage.getItem("partner_signup_token");
  const mobNumber = localStorage.getItem("Mobile");
  const emailIdUrl = localStorage.getItem("emailIdUrl");
  const mobileNoUrl = localStorage.getItem("mobileNoUrl");
  // const resumeDetails = localStorage.getItem("resumeDetails");
  const resumeDetails = JSON.parse(localStorage.getItem("resumeDetails") || "{}");
  const [signupLoader, setSignupLoader] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [isEmailDisabled, setIsEmailDisabled] = useState(false);
  const inputRef = useRef(null);
  const [partnerData, setPartnerData] = useState("")


  const schema = Yup.object().shape({
    email: Yup.string()
      .required("Email ID is required")
      .matches(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~\-_]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*$/,
        // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        "Please enter a valid email ID"
      )
      .test(
        "no-invalid-combo",
        "Special characters like '_', '-', or '.' cannot be adjacent to '@' or each other.",
        (value) => {
          if (!value) return false;
          // Disallow patterns like _@, .@, -@, @_, @-, @., .-, -., etc.
          return !/[_.\-]{1}@|@[_.\-]{1}|[.\-_]{2,}/.test(value);
        }
      )
      .test('no-special-char-start', 'The local part of the email cannot start with a special character.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > 0) {
          const localPart = value.substring(0, atPos);
          if (/^[.!#$%&'*+/=?^_`{|}~-]/.test(localPart[0])) {
            return false;
          }
        }
        return true;
      })
      .test('dot-before-at', 'A dot (.) or special character cannot be immediately before the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > 0) {
          const charBeforeAt = value[atPos - 1];
          return /^[a-zA-Z0-9]$/.test(charBeforeAt);
        }
        return true;
      })
      .test('no-digit-after-at', 'The domain part cannot contain digits after the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > -1) {
          const domainPart = value.substring(atPos + 1);  // The part after '@'
          // Ensure that no digits exist in the domain part
          if (/\d/.test(domainPart)) {  // Check if there are digits anywhere after '@'
            return false;
          }
        }
        return true;
      })
      .test('no-special-char-after-at', 'The domain part cannot contain special characters after the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > -1) {
          const domainPart = value.substring(atPos + 1);  // The part after '@'
          // Ensure no special characters except for '.' in the domain part
          if (/[^a-zA-Z0-9.]/.test(domainPart)) {
            return false;
          }
        }
        return true;
      })
      .test('dot-required-after-at', 'The domain part must contain at least one dot (.) after the @ symbol.', (value) => {
        if (!value) return false;
        const atPos = value.indexOf('@');
        if (atPos > -1) {
          const domainPart = value.substring(atPos + 1); // The part after '@'
          if (!domainPart.includes('.')) {  // Check if the domain part contains a dot (.)
            return false;
          }
        }
        return true;
      }),
    otp1: Yup.string().when("otpSent", {
      is: true,
      then: Yup.string().required("Required"),
    }),
    otp2: Yup.string().when("otpSent", {
      is: true,
      then: Yup.string().required("Required"),
    }),
    otp3: Yup.string().when("otpSent", {
      is: true,
      then: Yup.string().required("Required"),
    }),
    otp4: Yup.string().when("otpSent", {
      is: true,
      then: Yup.string().required("Required"),
    }),
  });

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
    getValues,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: { email: emailIdUrl || "" },
  });

  const email = watch("email");

  const initFacebookPixel = () => {
    if (window.fbq) {
      window.fbq('track', 'SubmitApplication');
    } else {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      // Replace with your actual Facebook Pixel ID
      window.fbq('init', '2462375333984919');
      window.fbq('track', 'SubmitApplication');
    }
  };

  useEffect(() => {
    if (!partnerToken) navigate("/partner");
  }, [partnerToken]);

  useEffect(() => {
    if (emailIdUrl !== null) {
      document.getElementById("emailInput").disabled = true;
    }
    else {
      return
    }
  }, []);

  useEffect(() => {
    if (!otpSent) return;
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((s) => s - 1);
      } else if (minutes > 0) {
        setMinutes((m) => m - 1);
        setSeconds(59);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds, minutes, otpSent]);


  const sendOtp = async (data) => {
    setSignupLoader(true);
    try {
      let encPayload = encryptData(JSON.stringify({ email: data.email }));
      const res = await axios.post(Partner_Portal.GetSendOtp_Url, encPayload, {
        headers: { "Content-Type": "text/plain" },
      });

      const responseValue = JSON.parse(decryptData(res.data));
      if (responseValue?.status === 0) {
        setOtpSent(true);
        setIsEmailDisabled(true)
        reset({ email: data.email, otp1: "", otp2: "", otp3: "", otp4: "" });
        setMinutes(0);
        setSeconds(30);
      } else {
        toast.error(responseValue?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    } finally {
      setSignupLoader(false);
    }
  };

  const verifyOtp = async (data) => {
    const otp = otpFields.map((f) => data[f]).join("");
    if (otp.length !== 4) {
      toast.error("Enter full OTP");
      return;
    }

    try {
      let encPayload = encryptData(
        JSON.stringify({ email: data.email, otp })
      );
      const res = await axios.post(Partner_Portal.GetVerifyOtp_Url, encPayload, {
        headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${partnerToken}`,
        },
      });

      const responseValue = JSON.parse(decryptData(res.data));
      if (responseValue?.status === 0) {
        console.log(responseValue, "responseValue");
        const emailToken = responseValue?.data?.info?.token;
        setVerifyEmail(true);
        toast.success("OTP verified!");
        createSignupPartnerDetails(emailToken);
      } else {
        toast.error(responseValue?.message);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  const createSignupPartnerDetails = async (emailToken) => {
    setSignupLoader(true);
    try {

      const res = await axios.post(
        Partner_Portal.CreatePartner_Url,
        undefined,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${emailToken}`,
          },
        }
      );
      console.log(res.data, "decryptedData");

      const decryptedData = JSON.parse(decryptData(res.data));
      if (decryptedData?.status === 0) {
        navigate("/partner/document-upload");
      } else {
        setOtpSent(false);
        setVerifyEmail(false)
        setIsEmailDisabled(false);
        toast.error(decryptedData?.message);
      }
    } catch (error) {
      setOtpSent(false);
        setVerifyEmail(false)
        setIsEmailDisabled(false);
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    } finally {
      setSignupLoader(false);
    }
  };

  const resendOtp = () => {
    const email = getValues("email");
    if (validatePartnerEmail(email)) {
      sendOtp({ email });
    }
  };

  const previousBtn = () => navigate("/partner");

  const handleMobNumber = () => {
    setOtpSent(false);
    setIsEmailDisabled(false);
    setTimeout(() => {
      const el = document.querySelector("#emailInput");
      if (el) el.focus(); // optional, still safe
    }, 0);
  };

  const getSignupPartnerDetail = async () => {
    try {
      const getValues = await axios.get(
        Partner_Portal.CreatePartner_Url,

        {
          headers: {
            "Content-Type": "text/plain",
            Authorization: `Bearer ${partnerToken}`,
          },
        }
      );
      const signupResp = decryptData(getValues?.data);
      const decryptedData = JSON.parse(signupResp);

      if (decryptedData?.status === 0) {
        let partnerVal = decryptedData?.data?.info;
        setPartnerData(partnerVal)

        if (partnerVal?.email !== "") {
          setVerifyEmail(true);
          setIsEmailDisabled(true);
        }
        setValue("email", partnerVal?.email);
        console.log(partnerVal, "partnerVal");

      } else if (decryptedData?.status === 1) {
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 500) {
        toast.error("Your application couldn’t be processed due to a technical issue. Please try again.");
      }
      if (error?.request?.status === 401) {
        localStorage.clear("");
        navigate("/partner");
      }
    }
  };

  useEffect(() => {
    getSignupPartnerDetail();
  }, []);

  const handleNext = () => {
    localStorage.setItem("docSection", true);
    navigate("/partner/document-upload");
  };

  const onSubmit = (data) => {
    initFacebookPixel()
    if (otpSent) {
      verifyOtp(data)
    } else {
      sendOtp(data)
    }
  }

  const handlePaste = (e) => {
    e.preventDefault();
    let pastedText = e.clipboardData.getData("text");
    let clean = pastedText.replace(/[^a-zA-Z0-9@._-]/g, "");
    const atIndex = clean.indexOf("@");
    if (atIndex !== -1) {
      const beforeAt = clean.slice(0, atIndex + 1);
      const afterAt = clean.slice(atIndex + 1).replace(/@/g, "");
      clean = beforeAt + afterAt;
    }
    clean = clean.replace(/([_.-])@|@([_.-])/g, "@");
    clean = clean.replace(/([_.-])([_.-])/g, "$1");

    clean = clean.replace(/\.{2,}/g, ".");
    clean = clean.replace(/\.@/g, "@");
    clean = clean.replace(/^[@.]+|[@.]+$/g, "");
    clean = clean.slice(0, 63);

    setValue("email", clean, { shouldValidate: true });
  };

  const handleEmailInput = (e) => {
    let value = e.target.value;
    value = value.replace(/[^a-zA-Z0-9@._-]/g, "");

    if (/^[@.]/.test(value)) {
      value = value.substring(1);
    }
    const atParts = value.split("@");
    if (atParts.length > 2) {
      value = atParts[0] + "@" + atParts.slice(1).join("").replace(/@/g, "");
    }
    value = value.replace(/([_.-])@|@([_.-])/g, "@"); // remove invalid combos near '@'
    value = value.replace(/([_.-])([_.-])/g, "$1");

    value = value.replace(/\.{2,}/g, ".");
    value = value.replace(/\.@/, "@");
    value = value.replace(/@\.{1}/, "@");
    value = value.slice(0, 63);
    e.target.value = value;
    setValue("email", value, { shouldValidate: true });
  };

  return (
    <>
      <HeaderPartner />
      <PageProgressBarPartner progress="basic-details" partnerData={partnerData}/>

      <main className="main-content page-wrapper partner-page partner-page-postlogin">
        <div className="h-md-100 ">
          <Row className="h-md-100 p-0 m-0 mobile-view">
            <Col lg={6} className="p-0">
              <PageSideBar />
            </Col>
            <Col lg={6} className="p-0">
              <div className="page-header right-box">
                <div className="wrap-all">

                  <div className="page-left landing-page viewheight">
                    <img
                      className="previous-btn"
                      src={previosPageArrow}
                      alt="previous"
                      onClick={previousBtn}
                    />
                    <div className="heading-wrapper">
                      {verifyEmail ||
                        resumeDetails?.emailOtpVerified ||
                        emailIdUrl ? (
                        <>
                          <h2 className="page-title">
                            Great, you are progressing well!
                          </h2>
                          <h3 className="page-subtitle partner-subtitle">
                            We need a few details to confirm your identity
                          </h3>
                        </>
                      ) : (
                        <>
                          <h2 className="page-title">
                            Wonderful! You have crossed the 1st step!
                          </h2>
                          <h3 className="page-subtitle partner-subtitle">
                            Add PAN & Email carefully and proceed
                          </h3>
                        </>
                      )}
                    </div>

                  </div>

                  <form
                    onSubmit={handleSubmit(onSubmit)}
                    className="mt-4"
                    autoComplete="off"
                  >
                    <div className="mobile-wrapper partner-pan-wrapper">
                      <label className="text-label">
                        Enter Email Address
                        <span class="mandatory-label">*</span>
                      </label>
                      <input
                        type="text"
                        id="emailInput"
                        className="mt-2 form-control has-value is-invalid partner-mob"
                        autoComplete="off"
                        {...register("email")}
                        maxLength={63}
                        disabled={isEmailDisabled}
                        onKeyPress={(e) => {
                          if (e.key === " ") {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => handleEmailInput(e)}
                        onPaste={handlePaste}
                        placeholder="Enter your email address"
                      />
                      {errors?.email && (
                        <p className="forget-link">{errors?.email?.message}</p>
                      )}
                    </div>

                    {otpSent && !verifyEmail && (
                      <div className="otp-wrapper">
                        <div className="wrap-otp-content">
                          <p className="otp-enter">Enter OTP</p>
                          <p>
                            <div className="countdown-text">
                              <button
                                type="button"
                                className="btn-resend"
                                disabled={seconds > 0 || minutes > 0}
                                onClick={resendOtp}
                              >
                                Resend OTP
                              </button>
                              <span className="otpnumber">
                                {minutes.toString().padStart(2, "0")}:
                                {seconds.toString().padStart(2, "0")}
                              </span>
                            </div>
                          </p>
                        </div>

                        <div>
                          <form id="otp-form">
                            <div className="form-group">
                              {otpFields.map((field, idx) => (
                                <input
                                  key={field}
                                  type="text"
                                  maxLength="1"
                                  className="otp-form-control"
                                  {...register(field)}
                                  onInput={(e) => {
                                    digitValidate(e);
                                    oneDigit(e);
                                  }}
                                  onKeyUp={(e) => {
                                    const inputs = document.querySelectorAll(".otp-form-control");
                                    if (e.target.value && idx < inputs.length - 1) {
                                      inputs[idx + 1].focus();
                                    }
                                    if (e.key === "Backspace" && !e.target.value && idx > 0) {
                                      inputs[idx - 1].focus();
                                    }
                                  }}
                                />
                              ))}
                            </div>
                          </form>
                        </div>

                        <div className="otpsent-content">
                          <p>
                            OTP sent to {emailIdUrl !== null ? emailIdUrl : email}
                            {emailIdUrl == null && (
                              <div className="wrap-edit" onClick={handleMobNumber}>
                                <img className="edit-number" src={editNumber} alt="edit icon" />
                                <p className="edit-number">Edit</p>
                              </div>
                            )}
                          </p>
                        </div>
                      </div>
                    )}

                    {console.log(isEmailDisabled, verifyEmail, "isEmailDisabled")
                    }

                    {isEmailDisabled && verifyEmail ? (
                      <button
                        type="button"
                        className="partner-loginBtn"
                        onClick={handleNext}
                      >
                        Next
                      </button>
                    ) :
                      <button
                        className={`partner-loginBtn ${!otpSent && !validatePartnerEmail(email) ? "disable-esign-btn" : ""
                          }`}
                        type="submit"
                        disabled={signupLoader || (!otpSent && !validatePartnerEmail(email))}
                      >
                        {signupLoader ? <SmallLoader /> : otpSent ? "VERIFY" : "GET OTP"}
                      </button>
                    }

                  </form>
                </div>

                <div className="wrap-footerData">
                  <FormFooterPartner />
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </main>
    </>
  );
};
export default PANDetailPagePartner;
